import React from 'react';
import Icon from '../../../components/AppIcon';
import amberLogo from '../../../../assets/images/amber-logo.png';

const FormHeader = ({ steps = [], currentStep, regularizationMode }) => {
  const labels = steps.map((s) => s.label);
  const totalSteps = labels.length;

  return (
    <div className="bg-white border-b border-border shadow-sm">
      <div className="max-w-4xl mx-auto px-6 pt-7 pb-6">
        {/* Company Branding */}
        <div className="flex flex-col items-center justify-center mb-7">
          <div className="w-24 h-24 flex items-center justify-center mb-3">
            <img src={amberLogo} alt="Amber Enterprises Logo" className="w-full h-full object-contain" />
          </div>
          <div className="text-center">
            <h1 className="text-2xl font-semibold tracking-tight text-foreground">
              {regularizationMode ? 'Update Vendor Information' : 'Amber Enterprises India Limited'}
            </h1>
            <p className="mt-1 text-sm text-text-secondary">
              {regularizationMode
                ? 'Review and update your information. Changes will be reviewed by the administrator.'
                : 'Vendor Registration Portal'}
            </p>
          </div>
        </div>

        {/* Progress: each label sits under its own step marker; the track connects the markers */}
        <ol
          className="grid"
          style={{ gridTemplateColumns: `repeat(${totalSteps}, minmax(0, 1fr))` }}
          aria-label="Registration progress"
        >
          {labels.map((label, idx) => {
            const stepNumber = idx + 1;
            const isActive = stepNumber === currentStep;
            const isCompleted = stepNumber < currentStep;
            const trackReached = stepNumber <= currentStep;

            return (
              <li
                key={label}
                className="relative flex flex-col items-center text-center"
                aria-current={isActive ? 'step' : undefined}
              >
                {idx > 0 && (
                  <span
                    className={`absolute top-4 right-1/2 h-0.5 w-full transition-colors duration-300 ${
                      trackReached ? 'bg-success' : 'bg-border'
                    }`}
                    aria-hidden="true"
                  />
                )}
                <span
                  className={`relative z-10 flex h-8 w-8 items-center justify-center rounded-full text-sm font-semibold ring-4 ring-white transition-colors duration-300 ${
                    isActive
                      ? 'bg-primary text-primary-foreground shadow-[0_0_0_4px_hsl(var(--primary)/0.15)]'
                      : isCompleted
                        ? 'bg-success text-success-foreground'
                        : 'bg-muted text-text-secondary'
                  }`}
                >
                  {isCompleted ? <Icon name="Check" size={16} strokeWidth={3} /> : stepNumber}
                </span>
                <span
                  className={`mt-2 px-1 text-xs leading-tight ${
                    isActive ? 'font-semibold text-primary' : isCompleted ? 'text-foreground' : 'text-text-secondary'
                  }`}
                >
                  {label}
                </span>
              </li>
            );
          })}
        </ol>
      </div>
    </div>
  );
};

export default FormHeader;
